module.exports = __webpack_public_path__ + "img/TK.a084916a.png";